import { gql } from "@apollo/client";

export const CREATE_REGION = gql`
    mutation createRegion($data: CreateActingRegionInput!) {
        createRegion(data: $data) {
            id
            name
            ibge
        }
    }
`;

export const UPDATE_REGION = gql`
    mutation updateRegion($data: UpdateActingRegionInput!) {
        updateRegion(data: $data) {
            id
            name
            ibge
            latitude
            longitude
            is_actived
            is_deleted
        }
    }
`;

export default CREATE_REGION;
